/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from 'react';

const useDelay = (time = 0) => {
    const [showAfterDelay, setShowAfterDelay] = useState(time === 0);

    useEffect(() => {
        if (time > 0) {
            const timer = setTimeout(
                () => setShowAfterDelay(true),
                time * 1000
            );
            return () => timer && clearTimeout(timer);
        }
    }, []);

    return {
        showAfterDelay
    };
};

export default useDelay;
